export enum DocumentUrls {
  Document = "Document/",
  GetDocument = "Document/GetDocument",
  NewDirectory = "Document/NewDirectory",
  EditDocument = "/EditDocument",
  DeleteDocument = "/DeleteDocument",
  NewFile = "Document/NewFile",
  GetFile = "/GetFile",
}
